import {
  IsString,
  IsIn,
  IsNotEmptyObject,
  IsNotEmpty,
  ValidateNested,
  IsBoolean,
  IsOptional,
} from 'class-validator';
// import { BillingData } from 'business-layer/types';

const gateways = ['StripePlatformGateway', 'AdyenGateway'] as const;
export type GatewayType = typeof gateways[number];

export const LinkStatus = {
  Sent: 'sent',
  Completed: 'completed',
  Paid: 'paid',
  Expired: 'expired',
  Cancelled: 'cancelled',
  Processing: 'processing', //3ds
} as const;
export type TLinkStatus = typeof LinkStatus[keyof typeof LinkStatus];

export type TBillingMandatoryValue = 'mandatory';
export type TBillingDisplayValue = 'display';

export type TBillingData = {
  country_billing_address_display?: TBillingDisplayValue;
  country_billing_address_mandatory?: TBillingMandatoryValue;
  zip_billing_address_display?: TBillingDisplayValue;
  zip_billing_address_mandatory?: TBillingMandatoryValue;
  address1_billing_address_display?: TBillingDisplayValue;
  address1_billing_address_mandatory?: TBillingMandatoryValue;
  address2_billing_address_display?: TBillingDisplayValue;
  address2_billing_address_mandatory?: TBillingMandatoryValue;
  city_billing_address_display?: TBillingDisplayValue;
  city_billing_address_mandatory?: TBillingMandatoryValue;
  state_billing_address_display?: TBillingDisplayValue;
  state_billing_address_mandatory?: TBillingMandatoryValue;
  email_billing_address_display?: TBillingDisplayValue;
  email_billing_address_mandatory?: TBillingMandatoryValue;
}

export class GatewayUser {
  @IsString()
  login: string;
}

export class GatewayConfig {
  @IsString()
  clientKey: string;

  @IsOptional()
  @IsString()
  apiVersion: string;

  @IsOptional()
  @IsString()
  env: string;
}

export class PaymentGatewayDto {
  // @IsInt()
  // @Transform(({ value }) => +value, { toClassOnly: true })
  // id: number;
  @IsBoolean()
  isActive: Boolean;

  @IsString()
  mode: string;

  @IsString()
  status: TLinkStatus;

  @IsIn(gateways)
  gateway: GatewayType;

  // @IsOptional()
  // @IsString()
  // country: string;

  // @IsOptional()
  // @IsString()
  // currency: string;

  @ValidateNested()
  @IsNotEmptyObject()
  gatewayConfig: GatewayConfig;

  @IsNotEmpty()
  paymentMethods: string[];

  @IsOptional()
  billingAddressFields: TBillingData;
};
